'use strict';
import MODULE_NAME from '../../app'

angular.module(MODULE_NAME).config(['$stateProvider', '$urlRouterProvider', '$translateProvider', function($stateProvider, $urlRouterProvider, $translateProvider) {
    $urlRouterProvider.otherwise('/map');
    $stateProvider.state('map', {
      url: '/map',
      views: {
        '': {templateUrl: 'views/container.html'},
        'flexibleMapSpace@map': {templateUrl: 'views/map.html', controller: 'MapController'},
        'flexibleSearchSpace@map' : {templateUrl: 'views/search.html', controller: 'SearchController'},
        'flexibleFloatingBoxSpace@map' : {templateUrl: 'views/floatingBox.html', controller: 'FloatingBoxController'},
        'flexibleDetailsSpace@map' : {templateUrl: 'views/details.html', controller: 'DetailsController'},
        'flexibleEmailSpace@map' : {templateUrl: 'views/email.html', controller: 'EmailController'},
        'flexibleConstructionSiteSupervisorsSpace@map' : {templateUrl: 'views/constructionSiteSupervisors.html', controller: 'ConstructionSiteSupervisorsController'},
        'flexibleAboutSpace@map' : {templateUrl: 'views/about.html', controller: 'AboutController'},
        'flexibleLayersConfiguratorSpace@map' : {templateUrl: 'views/layersConfigurator.html', controller: 'LayersConfiguratorController'},
        'flexibleLegendSpace@map' : {templateUrl: 'views/legend.html', controller: 'LegendController'},
        'flexibleVideoSpace@map' : {templateUrl: 'views/video.html', controller: 'VideoController'},
        'flexibleAlbumPhotosSpace@map' : {templateUrl: 'views/albumPhotos.html', controller: 'AlbumPhotosController'},
        'flexibleAlbumPhotosDetailsSpace@map' : {templateUrl: 'views/albumPhotosDetails.html', controller: 'AlbumPhotosDetailsController'},
        'flexibleEdictSpace@map' : {templateUrl: 'views/edict.html', controller: 'EdictController'},
        'flexibleLicensesEnvironmentalSpace@map' : {templateUrl: 'views/licensesEnvironmental.html', controller: 'LicensesEnvironmentalController'},
      }
    });

    $translateProvider.useStaticFilesLoader({ prefix:
    'components/i18n/locale-', suffix: '.json' });
    $translateProvider.preferredLanguage('pt-BR');
    $translateProvider.fallbackLanguage('pt-BR'); 
  }]);
require('./run')



// WEBPACK FOOTER //
// ./src/app/scripts/configs/index.js